import PaginationOne from "./PaginationOne";

export default PaginationOne;
